import { createSport8RefundAudit, getSport8RefundAudit } from '../../../api/sport8Api'
import translate from '../../../i18n'
import { RefundReasonCodeOptions } from '../constant'
import { ISport8RefundAuditFormValue } from '../share-type'
import { Button, Form, Input, notification } from 'antd'
import Search from 'antd/es/input/Search'
import Select from 'antd/es/select'
import TextArea from 'antd/lib/input/TextArea'
import { useNavigate } from 'react-router-dom'

const Sport8RefundAuditForm = () => {
  const [form] = Form.useForm()
  const navigate = useNavigate()

  const fetchSport8RefundAudit = (value: string) => {
    if (!value) {
      form.setFieldsValue({
        auditTradeNo: '',
        outTradeNo: '',
        thirdTradeNo: '',
        refundAmount: '',
        refundReason: '',
        refundReasonCode: '',
      })
      return
    }
    getSport8RefundAudit(Number(value))
      .then(res => {
        if (res.booking.externalProviderId && res.studioIntegrationBookingInfo.price) {
          form.setFieldsValue({
            auditTradeNo: res.studioIntegrationBookingInfo.auditTradeNo,
            outTradeNo: res.booking.externalProviderId.split(':')[0],
            thirdTradeNo: res.booking.externalProviderId.split(':')[1],
            refundAmount: res.studioIntegrationBookingInfo.price,
            refundReason: '',
            refundReasonCode: '',
          })
        }
        if (res.studioIntegrationBookingInfo.auditTradeNo) {
          notification.warning({
            description: translate('sport8RefundAudits.alreadySendRefundAudit'),
          })
          return
        }
      })
      .catch(err => {
        notification.error({ title: translate('error'), description: err.message })
      })
  }

  const onFinish = (values: ISport8RefundAuditFormValue) => {
    createSport8RefundAudit(values.bookingId, values.refundReasonCode, values.refundReason)
      .then(() => {
        notification.success({
          title: translate('sport8RefundAudits.createSport8RefundAudit') + translate('success'),
        })
        navigate(`/sport8-refund-audits/${values.bookingId}`)
      })
      .catch(err => {
        notification.error({ title: translate('error'), description: err.message })
      })
  }

  return (
    <Form
      labelCol={{ span: 6 }}
      wrapperCol={{ span: 12 }}
      autoComplete="off"
      style={{ maxWidth: 1000 }}
      form={form}
      onFinish={onFinish}
    >
      <Form.Item label={translate('sport8RefundAudits.bookingId')} name="bookingId">
        <Search onSearch={fetchSport8RefundAudit} enterButton={translate('search')} />
      </Form.Item>
      <Form.Item label={translate('sport8RefundAudits.auditTradeNo')} name="auditTradeNo">
        <Input readOnly />
      </Form.Item>
      <Form.Item label={translate('sport8RefundAudits.outTradeNo')} name="outTradeNo">
        <Input readOnly />
      </Form.Item>
      <Form.Item label={translate('sport8RefundAudits.thirdTradeNo')} name="thirdTradeNo">
        <Input readOnly />
      </Form.Item>
      <Form.Item label={translate('sport8RefundAudits.refundAmount')} name="refundAmount">
        <Input readOnly />
      </Form.Item>
      <Form.Item
        label={translate('sport8RefundAudits.refundReasonCode')}
        name="refundReasonCode"
        rules={[{ required: true }]}
      >
        <Select options={RefundReasonCodeOptions} />
      </Form.Item>
      <Form.Item
        label={translate('sport8RefundAudits.refundReason')}
        name="refundReason"
        rules={[{ required: true }]}
      >
        <TextArea />
      </Form.Item>
      <Form.Item wrapperCol={{ offset: 8, span: 16 }}>
        <Button type="primary" htmlType="submit">
          {translate('submit')}
        </Button>
      </Form.Item>
    </Form>
  )
}

export default Sport8RefundAuditForm
